import { Component, OnInit, AfterViewInit, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { AdminSidebarComponent } from '../sidebar/admin-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { AssetRequestComponent } from '../../shared/components/asset-request/asset-request.component';
import { AclApdApiService } from '@angular-workspace/services';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-admin-access-requests',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    AdminSidebarComponent,
    PageHeaderComponent,
    AssetRequestComponent,
  ],
  templateUrl: './access-requests.component.html',
  styleUrl: './access-requests.component.scss',
})
export class AdminAccessRequestsComponent implements OnInit, AfterViewInit {
  @ViewChild(AssetRequestComponent) assetRequestComponent!: AssetRequestComponent;

  private aclApdApiService = inject(AclApdApiService);
  private cdr = inject(ChangeDetectorRef);
  private keycloak = inject(KeycloakService);

  async ngOnInit(): Promise<void> {
    // Data loading moved to ngAfterViewInit to ensure ViewChild is available
  }

  async ngAfterViewInit(): Promise<void> {
    // Wait for next tick to ensure child component is fully initialized
    await Promise.resolve();

    // Wait for Keycloak to be ready before making API calls
    await this.waitForKeycloakReady();

    await this.loadAssetRequests();
  }

  private async waitForKeycloakReady(): Promise<void> {
    try {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance?.authenticated && keycloakInstance?.token) {
        return;
      }

      const maxWaitTime = 5000;
      const checkInterval = 100;
      const startTime = Date.now();

      while (Date.now() - startTime < maxWaitTime) {
        const instance = this.keycloak.getKeycloakInstance();
        if (instance?.authenticated && instance?.token) {
          return;
        }
        await new Promise((resolve) => setTimeout(resolve, checkInterval));
      }
    } catch (error) {
      console.error('Error waiting for Keycloak:', error);
    }
  }

  async loadAssetRequests(): Promise<void> {
    try {
      if (!this.assetRequestComponent) {
        return;
      }

      const page = this.assetRequestComponent.pagination?.currentPage || 1;
      const size = this.assetRequestComponent.pagination?.pageSize || 10;
      const response = await this.aclApdApiService.platformAssetRequests(page, size);

      this.assetRequestComponent.mapProviderAssetRequestsResponse(response);
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error loading admin asset requests:', error);
      if (this.assetRequestComponent) {
        this.assetRequestComponent.loading = false;
      }
    }
  }
}
